<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">

        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">
                {{ isEditing ? 'Редактировать пользователя' : 'Создать нового пользователя' }}
              </h4>
            </div>
            <div class="card-body">

              <div v-if="successMessage" class="alert alert-success">
                <span>{{ successMessage }}</span>
                <button type="button" class="close" @click="successMessage = null">×</button>
              </div>

              <div v-if="errorMessage" class="alert alert-danger">
                <span>{{ errorMessage }}</span>
                <button type="button" class="close" @click="errorMessage = null">×</button>
              </div>

              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Имя (Name)</label>
                      <input type="text" class="form-control" v-model="form.name" required>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Логин (Username)</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.username"
                        :disabled="isEditing"
                        :placeholder="isEditing ? 'Нельзя изменить' : 'Логин'"
                        :required="!isEditing"
                      >
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Пароль</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.password"
                        :placeholder="isEditing ? 'Оставьте пустым, чтобы не менять' : 'Пароль'"
                        :required="!isEditing"
                      >
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Роль</label>
                      <select class="form-control" v-model="form.role" disabled>
                        <option :value="1">Пользователь (1)</option>
                        <option :value="2">Админ</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-info btn-fill pull-right" :disabled="loading">
                      {{ loading ? 'Сохранение...' : (isEditing ? 'Обновить' : 'Создать') }}
                    </button>

                    <button
                      v-if="isEditing"
                      type="button"
                      class="btn btn-secondary btn-fill pull-right mr-2"
                      @click="cancelEdit"
                      style="margin-right: 10px;"
                    >
                      Отмена
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="card">

            <div class="card-header d-flex justify-content-between align-items-center">
              <div>
                <h4 class="card-title">Список пользователей</h4>
              </div>

              <div class="pagination-controls" v-if="users.length > 0 || pageIndex > 1">
                 <button
                   class="btn btn-sm btn-secondary btn-fill"
                   :disabled="pageIndex === 1 || fetching"
                   @click="changePage(-1)"
                 >
                   <i class="fa fa-chevron-left"></i> Назад
                 </button>

                 <span class="mx-3 font-weight-bold">Стр. {{ pageIndex }}</span>

                 <button
                   class="btn btn-sm btn-secondary btn-fill"
                   :disabled="isLastPage || fetching"
                   @click="changePage(1)"
                 >
                   Вперед <i class="fa fa-chevron-right"></i>
                 </button>
              </div>
            </div>

            <div class="card-body table-full-width table-responsive">
              <table class="table table-hover table-striped">
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Имя</th>
                    <th>Логин</th>
                    <th>Роль</th>
                    <th>Создан</th>
                    <th class="text-right">Действия</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="fetching">
                    <td colspan="6" class="text-center">Загрузка...</td>
                  </tr>
                  <tr v-if="!fetching && users.length === 0">
                    <td colspan="6" class="text-center">Список пуст</td>
                  </tr>
                  <tr v-for="(user, index) in users" :key="user.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ user.name }}</td>
                    <td>{{ user.username }}</td>
                    <td>
                      <span class="badge" :class="user.role === 2 ? 'badge-primary' : 'badge-secondary'">
                        {{ getRoleName(user.role) }}
                      </span>
                    </td>
                    <td>{{ formatDate(user.createdAt) }}</td>
                    <td class="text-right">
                      <button class="btn btn-warning btn-sm btn-fill" @click="editUser(user)" style="margin-right: 5px;">
                        <i class='bx bx-edit'></i>
                      </button>
                      <button class="btn btn-danger btn-sm btn-fill" @click="deleteUser(user.id)">
                        <i class='bx bx-trash'></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="text-muted small p-3" v-if="users.length > 0">
                 Показано {{ users.length }} записей (Лимит: {{ pageSize }})
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// ✅ IMPORT API_URL HERE
import { API_URL } from '../server';

export default {
  name: 'UserList',
  data() {
    return {
      users: [],
      fetching: false,
      loading: false,

      // Pagination Data
      pageIndex: 1,
      pageSize: 50,
      isLastPage: false,

      // Edit State
      isEditing: false,
      currentUserId: null,

      // Form Data
      form: {
        name: '',
        username: '',
        password: '',
        role: 2
      },

      successMessage: null,
      errorMessage: null
    };
  },
  mounted() {
    this.fetchUsers();
  },
  methods: {
    // 1. GET ALL USERS (With Pagination)
    async fetchUsers() {
      this.fetching = true;
      const token = localStorage.getItem('token');
      try {
        // ✅ USE API_URL + Endpoint + Params
        const response = await axios.get(API_URL + '/api/user', {
          headers: { 'Authorization': `Bearer ${token}` },
          params: {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        });

        if (response.data && response.data.code === 200) {
          const data = response.data.data || [];
          this.users = data;
          // Determine if we are on the last page
          this.isLastPage = data.length < this.pageSize;
        } else {
          this.users = [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.fetching = false;
      }
    },

    // 2. Change Page
    changePage(direction) {
      this.pageIndex += direction;
      this.fetchUsers();
    },

    // 3. SUBMIT (Create or Update)
    async submitForm() {
      if (this.isEditing) {
        await this.updateUser();
      } else {
        await this.createUser();
      }
    },

    // 3a. CREATE USER
    async createUser() {
      this.loading = true;
      this.errorMessage = null;
      this.successMessage = null;
      const token = localStorage.getItem('token');

      try {
        const payload = {
          name: this.form.name,
          username: this.form.username,
          password: this.form.password,
        };

        const response = await axios.post(API_URL + '/api/user', payload, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.data && response.data.code === 200) {
          this.successMessage = 'Пользователь успешно создан!';
          this.resetForm();
          // Reset to page 1 to see new user
          this.pageIndex = 1;
          this.fetchUsers();
        } else {
          this.errorMessage = 'Ошибка создания пользователя.';
        }
      } catch (error) {
        console.error(error);
        this.errorMessage = 'Ошибка сервера.';
      } finally {
        this.loading = false;
      }
    },

    // 3b. UPDATE USER
    async updateUser() {
      this.loading = true;
      this.errorMessage = null;
      this.successMessage = null;
      const token = localStorage.getItem('token');

      try {
        const formData = new FormData();
        formData.append('Name', this.form.name);
        formData.append('Role', this.form.role);

        if (this.form.password && this.form.password.length > 0) {
          formData.append('Password', this.form.password);
        }

        const response = await axios.put(
          API_URL + `/api/user/${this.currentUserId}`,
          formData,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );

        if (response.data && response.data.code === 200) {
          this.successMessage = 'Пользователь успешно обновлен!';
          this.resetForm();
          this.fetchUsers(); // Stays on current page
        } else {
          this.errorMessage = 'Ошибка обновления.';
        }
      } catch (error) {
        console.error(error);
        this.errorMessage = 'Ошибка сервера при обновлении.';
      } finally {
        this.loading = false;
      }
    },

    // 4. DELETE USER
    async deleteUser(id) {
      if (!confirm('Вы уверены? Удаление необратимо.')) return;

      const token = localStorage.getItem('token');
      try {
        const response = await axios.delete(API_URL + `/api/user/${id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if (response.data && response.data.code === 200) {
          this.successMessage = 'Пользователь удален.';

          if (this.isEditing && this.currentUserId === id) {
             this.resetForm();
          }

          this.fetchUsers(); // Refresh current page
        } else {
          this.errorMessage = 'Не удалось удалить.';
        }
      } catch (error) {
        console.error(error);
        this.errorMessage = 'Ошибка при удалении.';
      }
    },

    // PREPARE EDIT
    editUser(user) {
      this.isEditing = true;
      this.currentUserId = user.id;
      this.form.name = user.name;
      this.form.username = user.username;
      this.form.role = user.role;
      this.form.password = '';

      window.scrollTo(0,0);
    },

    // CANCEL EDIT
    cancelEdit() {
      this.resetForm();
    },

    resetForm() {
      this.isEditing = false;
      this.currentUserId = null;
      this.form = {
        name: '',
        username: '',
        password: '',
        role: 2
      };
    },

    // Helpers
    formatDate(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleString('ru-RU');
    },
    getRoleName(roleId) {
      if (roleId === 2) return 'Администратор';
      if (roleId === 1) return 'Администратор';
      return 'Неизвестно';
    }
  }
};
</script>

<style scoped>
.badge { padding: 5px 10px; border-radius: 4px; color: white; }
.badge-primary { background-color: #007bff; }
.badge-secondary { background-color: #6c757d; }
.close { float: right; font-size: 1.5rem; font-weight: 700; line-height: 1; color: #000; text-shadow: 0 1px 0 #fff; opacity: .5; background: transparent; border: 0; cursor: pointer;}
.pagination-controls { display: flex; align-items: center; }
.mx-3 { margin-left: 1rem; margin-right: 1rem; }
</style>
